import './orders.css';
import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite';
import { Link, useNavigate, useParams } from 'react-router-dom';
import ContentBlock from '../../common/elements/content-block';
import Column from "../../common/marking/column"
import Select from './elements/select';
import Input from './elements/input';
import Textarea from './elements/textarea';
import TableCardShop from '../../common/table/TableCardShop';
import api from "../../../services/api"
import Foother from '../../common/marking/foother';
import ButtonSave from '../../common/elements/button-save';
import CardShop from './card-shop';
import Customer from './elements/customer';
import TaskBar from './elements/task-bar';
import orderStorage from '../../../storage/order'
import AddressModule from '../Address/AddressModule';
import Row from '../../common/marking/row';
import DeliveryType from './elements/delivery-type';

const OrderEdit = observer(() => {

    const { setGoodsInCardArray} = orderStorage;

    const [ goodsGroup, setGoodsGroup ] = useState(null);
    const [ goods, setGoods ] = useState(null)
    const [ managers, setManagers ] = useState(null)
    const [ typeLeads, setTypeLeads ] = useState(null)
    const [ typeOrder, setTypeOrder ] = useState(null)
    const [ shops, setShops ] = useState(null)
    const [ warehouse, setWarehouse ] = useState(null)
    const [ goodsTag, setGoodsTag ] = useState(null)
    const [ customers, setCustomers ] = useState([])
    const [ customer, setCustomer ] = useState(null)
    const [ firstname, setFirstname ] = useState(null)
    const [ surname, setSurname ] = useState(null)
    const [ patronymic, setPatronymic ] = useState(null)
    const [ email, setEmail ] = useState(null)
    const [ phone, setPhone ] = useState(null)

    // eslint-disable-next-line
    const navigator = useNavigate()
    const { id } = useParams();
    const [ order, setOrder ] = useState(null)
    const [ status, setStatus ] = useState(false)

    const clearActiveCustomer = () => {
        setCustomer(null)
    }

    const changeReservation = () => {
        const getData = async () => {
            const data = new FormData()
            data.append('id', Number(id))
            await api.post('/orders/make-reservation', data)
                .then(res => setStatus(!status))
                .catch(e => console.log(e))
        }
        getData()
    }

    const getCustomer = (id) => {
        let data = new FormData()
        data.append('id', Number(id))
        api.post('/customer/get-customer', data)
            .then(res => setCustomer(res.data))
            .catch(e => console.log(e))

        const area = document.querySelector('#customer-list-right')
        area.classList.add('d-none')

        const activeUser = document.querySelector('#active-customer')
        activeUser.classList.remove('d-none')
        activeUser.classList.add('padding-bottom-none')
    }

    const chooseCustomer = async (event) => {
        let customer = event.target.parentElement.dataset.customers;
        if (customer == null) customer = event.target.dataset.customers;
        
        getCustomer(customer)
    }

    const hideCustomersList = () => {
        const area = document.querySelector('#customer-list-right')
        area.classList.add('d-none')
    }

    useEffect(() => {
        const getData = async() => {
            await api.post('/goods/get-goods-group', {})
                .then(res => setGoodsGroup(res.data))
                .catch(e => console.log(e))
            await api.post('/goods/get-goods', {})
                .then(res => setGoods(res.data))
                .catch(e => console.log(e))
            await api.post('/orders/get-managers', {})
                .then(res => setManagers(res.data.map(item => {
                    return {
                        id: item.id,
                        name: `${item.username !== null ? item.username : ''} ${item.surname !== null ? item.surname : ''} ${item.patronymic !== null ? item.patronymic : ''}`
                    }
                })))
                .catch(e => console.log(e))
            await api.post('/orders/get-shops', {})
                .then(res => setShops(res.data))
                .catch(e => console.log(e))
            await api.post('/orders/get-type-leads', {})
                .then(res => setTypeLeads(res.data))
                .catch(e => console.log(e))
            await api.post('/orders/get-type-order', {})
                .then(res => setTypeOrder(res.data))
                .catch(e => console.log(e))
            await api.post('/orders/get-warehouse', {})
                .then(res => setWarehouse(res.data))
                .catch(e => console.log(e))
            await api.post('/goods/get-goods-tag', {})
                .then(res => setGoodsTag(res.data))
                .catch(e => console.log(e))
                let data = new FormData()
                data.append('id', id)
            await api.post('/orders/get-order', data)
                .then(res => {
                    setOrder(res.data)
                })
                .catch(e => console.log(e))
        }
        getData()
        setGoodsInCardArray([])
        // eslint-disable-next-line
    },[])
    

    useEffect(() => {
        const area = document.querySelector('#customer-list-right')
        if (area !== null) {

            if (customers.length === 0) area.classList.add('d-none')
            else area.classList.remove('d-none')

            let html = '';
            if (customers.length > 0) 
                customers.forEach(item => {
                    html += `
                        <div data-customers="${item.id}">
                            <div>${item.firstname} ${item.surname !== null ? item.surname : ''} ${item.patronymic !== null ? item.patronymic : ''}</div>
                            <div>${item.users ? item.users.username : 'свободен'}</div>
                        </div>`
                })
            
                html += `
                    <div class="customer-list-btn" id="customer-list-btn">
                        <div>Новый клиент</div>
                    </div>`
                
            area.innerHTML = html;
            
            const button = document.querySelector('#customer-list-btn')
            button.removeEventListener('click', hideCustomersList)
            button.addEventListener('click', hideCustomersList)

            const listCustomers = document.querySelectorAll('[data-customers]')
            listCustomers.forEach(item => {
                item.removeEventListener('click', chooseCustomer)
                item.addEventListener('click', chooseCustomer)
            })
        }

    // eslint-disable-next-line
    }, [customers])

    useEffect(() => {
        const firstname = document.querySelector('#customer-firstname')
        const surname = document.querySelector('#customer-surname')
        const patronymic = document.querySelector('#customer-patronymic')
        const email = document.querySelector('#customer-email')
        const phone = document.querySelector('#customer-phone')

        if (firstname !== null &&
            surname !== null &&
            patronymic !== null &&
            email !== null &&
            phone !== null) {

            if (customer === null) {
                firstname.disabled = false
                surname.disabled = false
                patronymic.disabled = false
                email.disabled = false
                phone.disabled = false
            } else {
                firstname.disabled = true
                firstname.value = order.customers.firstname
                surname.disabled = true
                surname.value = order.customers.surname
                patronymic.disabled = true
                patronymic.value = order.customers.patronymic
                email.disabled = true
                email.value = order.customers.email
                phone.disabled = true
                phone.value = order.customers.phone
            }
        }
    // eslint-disable-next-line
    }, [customer])

    useEffect(() => {
        if (order != null) {
            getCustomer(order.customers.id)      
        }
        if (order != null) {
            if (order.reservation != null) {
                setStatus(order.reservation)
            }
        }
    // eslint-disable-next-line 
    }, [order])

    useEffect(() => {
        const getCustomer = async (firstname, surname, patronymic) => {
            let data = new FormData()
            data.append('firstname', firstname)
            data.append('surname', surname)
            data.append('patronymic', patronymic)

            await api.post('/customer/get-customer-name', data)
                .then(res => setCustomers(res.data))
                .catch(e => console.log(e))
        }
        getCustomer(firstname, surname, patronymic)
    }, [firstname, surname, patronymic])

    useEffect(() => {
        const getCustomer = async (email) => {
            let data = new FormData()
            data.append('email', email)

            await api.post('/customer/get-customer-email', data)
                // .then(res => setCustomers(res.data))
                .catch(e => console.log(e))
        }
        getCustomer(email)
    }, [email])

    useEffect(() => {
        const getCustomer = async (phone) => {
            let data = new FormData()
            data.append('phone', phone)

            await api.post('/customer/get-customer-phone', data)
                // .then(res => setCustomers(res.data))
                .catch(e => console.log(e))
        }
        getCustomer(phone)
    }, [phone])

    return (
        <div>
            { order === null ? <div className='preloader-block'><div className='loader'></div></div> :
                <div>
                    <CardShop 
                        warehouseFilter={warehouse} 
                        shopsFilter={shops}
                        goodsGroupFilter={goodsGroup}
                        goodsTagFilter={goodsTag}
                        goodsFilter={goods}
                        />
                    <div className="Order">
                        <div className='order-top'>
                            <div className='order-links'>
                                <Link to={'/'}>Главная</Link>
                                <span>→</span>
                                <Link to={'/sales/orders'}>Заказы</Link>
                            </div>
                            <div className='order-h1'>
                                Заказ { order !== null ? order.id : '' }
                                <div className='order-h1-container'>
                                    <div className='order-h1-head'>Сумма заказа</div>
                                    <div className='order-h1-body'>{order !== null ? order.shopCard.reduce((acc, item) => acc + item.count * item.goods.price, 0) - order.discount : ''} ₽</div>
                                </div>
                                <div className='order-h1-container'>
                                    <div className='order-h1-head'>Поступил</div>
                                    <div className='order-h1-body order-h1-body__nobold'>{ order !== null ? new Date(order.dateCreated).toLocaleString() : '' }</div>
                                </div>
                            </div>
                            { order !== null ? <TaskBar order={order}/> : '' }
                        </div>
                        <ContentBlock title="Основное" name="common" defaultState={true} button={null} content={
                            <div className='ContentBlockBody'>
                                <Column contant={
                                    <div>
                                        {managers !== null && order !== null ? <Select title="Менеджер" name="manager" data={managers} value={order.user !== null ? order.user.id : ""} /> : ''}
                                        {typeLeads !== null && order !== null ? <Select title="Способ" name="type_leads" data={typeLeads} value={order.typeLeads !== null ? order.typeLeads.id : ""} /> : ''}
                                    </div>
                                }/>
                                <Column contant={
                                    <div>
                                        {typeOrder !== null && order !== null ? <Select title="Тип заказа" name="type_order" data={typeOrder} value={order.typeOrder !== null ? order.typeOrder.id : ""} /> : ''}
                                        {shops !== null && order !== null ? <Select title="Магазин" name="shops" data={shops} value={order.shops !== null ? order.shops.id : ""} /> : ''}
                                    </div>
                                }/>
                            </div>
                        }/>
                        <ContentBlock title="Клиент" name="customer" defaultState={true} button={null} content={
                            <div className='ContentBlockBody'>
                                <Customer customer={customer} id="active-customer" method={clearActiveCustomer}/>
                                <Column contant={
                                    <div>
                                        <Input title="Фамилия" name="customer-surname" change={ setSurname }/>
                                        <Input title="Имя" name="customer-firstname" change={ setFirstname }/>
                                        <Input title="Отчество" name="customer-patronymic" change={ setPatronymic }/>
                                    </div>
                                }/>
                                <Column contant={
                                    <div>
                                        <div className='customer-list' id="customer-list-right"></div>
                                        <Input title="Email" name="customer-email" change={ setEmail }/>
                                        <Input title="Телефон" name="customer-phone" change={ setPhone }/>
                                    </div>
                                }/>
                            </div>
                        }/>
                        <ContentBlock title="Состав заказа" name="card-shop" defaultState={true} button={
                            <div className='table-goods-top-btn'>Добавить товар</div>
                        } content={
                            <div className='ContentBlockBody'>
                                <div className='order-reservation-block'>
                                    <div 
                                        className={ status ? 'order-reservation-block__button order-reservation-block-button__active' : 'order-reservation-block__button' }
                                        onClick={ changeReservation } >Забронировать</div>
                                </div>
                                { order !== null && goodsGroup !== null && goods !== null ? <TableCardShop goods={ goods } activeGoods={order !== null ? order.shopCard.map(item => {
                                    return {
                                        id: item.goods.id,
                                        count: item.count
                                    }
                                }) : []} discauntEnter={order !== null ? order.discount : ""} /> : '' }
                            </div>
                        }/>
                        <ContentBlock title="Доставка" name="comments" defaultState={true} button={null} content={
                            <div className='ContentBlockBody'>
                                <Row contant={
                                    <div>
                                        <AddressModule />
                                        <DeliveryType />
                                    </div>
                                }/>
                            </div>
                        }/>
                        <ContentBlock title="Комментарии" name="comments" defaultState={true} button={null} content={
                            <div className='ContentBlockBody'>
                                <Column contant={
                                    <div>
                                        <Textarea title="Комментарии клиента" name="comments-customer" value={order !== null ? order.commentCustomer : ""} />
                                    </div>
                                }/>
                                <Column contant={
                                    <div>
                                        <Textarea title="Комментарии оператора" name="comments-manager" value={order !== null ? order.commentManager : ""} />
                                    </div>
                                }/>
                            </div>
                        }/>
                    </div>
                    <Foother contant={ 
                        <div className="user-foother">
                            <ButtonSave text="Сохранить" method={ ()=> {  } }/>
                            <div id="user-save__success">Сохранено</div>
                            <div id="user-save__wrong">Ошибка сохранения</div>
                        </div>
                    } />
                </div>
            }
        </div>
    )
})

export default OrderEdit;